import { useCirculatingSupplyHistoric } from '@/api';
import { ChartSkeleton, ChartTimeFilter, EntityName } from '@/components';
import { CryptoIcon, Flex, LineChart, formatNumber } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useChartPeriod } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const [data, error] = useCirculatingSupplyHistoric(chartDaysAgo);

  if (error) {
    throw error;
  }

  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return (
        <EntityName
          symbol2={
            <CryptoIcon
              name="DAI"
              address={tokensMapping('DAI').address}
              size="3"
            />
          }
          symbol1={
            <CryptoIcon
              name="USDS"
              address={tokensMapping('USDS').address}
              size="3"
            />
          }>
          {formatNumber(Number(value))}
        </EntityName>
      );
    }

    return formatValue;
  }, []);

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <LineChart
          key={'total'}
          data={data}
          datasets={[
            {
              xField: 'date',
              yField: 'total_circulating'
            }
          ]}
          yScaleValueFormatter={(value) => `${formatNumber(Number(value))}`}
          valueFormatter={valueFormatter}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
